import { axiosInstance } from ".";

export async function UnlockPhaseService({
  newJobType,
  newJobStartDate,
  newJobTitle,
  newJobComments,
}: {
  newJobType: string;
  newJobStartDate: string;
  newJobTitle: string;
  newJobComments: string;
}): Promise<any> {
 
  try {
    const response = await axiosInstance.post("/users/unlock-phase", {newJobType,
        newJobStartDate,
        newJobTitle,
        newJobComments,});
    return response.data;
  } catch (error: any) {
    if (error.response) {
      const { status, data } = error.response;
      if (status === 404) {
        console.error(`Endpoint not found`);
      } else {
        console.error(`API error: ${status} - ${data}`);
      }
    } else if (error.request) {
      console.error(`Network error: ${error.request}`);
    } else {
      console.error(`Error: ${error.message}`);
    }
  }
}

export async function takeActionAndEvaluateBusinessRules(): Promise<any> {
 
  try {
    const response = await axiosInstance.post("/users/evaluate-business-rules",);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      const { status, data } = error.response;
      if (status === 404) {
        console.error(`Endpoint not found`);
      } else {
        console.error(`API error: ${status} - ${data}`);
      }
    } else if (error.request) {
      console.error(`Network error: ${error.request}`);
    } else {
      console.error(`Error: ${error.message}`);
    }
  }
}